/* TDP - Materiautheque (sections tdp-ree-*) : dans l'editeur de theme,
   rebranche la fleche du bandeau 2 photos quand la section est rechargee.
   Sur le site, c'est tdp-pages.js qui s'en charge au chargement de la page
   (ne pas la brancher deux fois, sinon chaque clic s'annulerait). */
(function () {
  'use strict';
  if (window.tdpReemploiLoaded) return;
  window.tdpReemploiLoaded = true;
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-tdp-banner-switch]').forEach(function (el) {
      var arrow = el.querySelector('[data-tdp-banner-arrow]');
      if (!arrow) return;
      arrow.addEventListener('click', function () { el.classList.toggle('is-second'); });
    });
  });
})();
